<template>
    <div class="setting-page-content-wrapper chat-timing-settings">
        <div class="page-header">
            <div class="title">{{ $t("message.chatTimingSettings") }}</div>
            <div class="subtitle">{{ $t("settings.chatTimingSettingsSubtitles") }}</div>
        </div>
        <section>
            <div class="features">
                <FeatureItem
                    v-for="feature in features"
                    :key="feature.id"
                    :value="readValue(feature.id)"
                    @input="setValue(feature.id, $event)"
                    :title="feature.title"
                    :description="feature.description"
                    type="number"
                    :min="feature.min"
                    :max="feature.max"
                    :step="feature.step"
                    :icon="feature.icon"
                />
            </div>
        </section>
    </div>
</template>

<script>
import { mapState } from "vuex";
import log2 from "../../../../utils/log2";
import FeatureItem from "../components/FeatureItem.vue";

const log = log2("Settings/ChatTimingSettings");

export default {
    name: "ChatTimingSettings",
    components: {
        FeatureItem,
    },
    props: {
        updateSettings: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            features: [
                {
                    title: this.$t("message.delayedTalkTime"),
                    description: this.$t("message.vtipyDelayedTalkTime"),
                    icon: "DelayTimeIcon",
                    id: "overdueTime",
                    min: 0,
                    max: 999999999,
                    step: 1,
                },
                {
                    title: this.$t("message.wasted"),
                    description: this.$t("message.vtipyCustomerDownTimeWhenRepExit"),
                    icon: "fallIcon",
                    id: "lostConversationTime",
                    min: 5,
                    max: 999999999,
                    step: 1,
                },
                {
                    title: this.$t("message.disconnectTime"),
                    description: this.$t("message.tippyDisconnectTime"),
                    icon: "SpeechHideIcon",
                    id: "disconnectTime",
                    min: 20,
                    max: 999999999,
                    step: 1,
                },
                {
                    title: this.$t("message.inactiveThresholdTime"),
                    description: this.$t("message.tippyInactiveThresholdTime"),
                    icon: "PassiveChatIcon",
                    id: "inactiveThresholdTime",
                    min: 1,
                    max: 120,
                    step: 1,
                },
                {
                    title: this.$t("message.inactiveTerminateTime"),
                    description: this.$t("message.tippyInactiveTerminateTime"),
                    icon: "ClosingUserIcon",
                    id: "inactiveTerminateTime",
                    min: 0,
                    max: 120,
                    step: 1,
                },
            ],
        };
    },

    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
        }),
        overdueTime: {
            get() {
                return this.settings.overdueTime;
            },
            set(value) {
                this.updateSettings("overdueTime", parseInt(value));
            },
        },
        autoAssignDefaultLimit: {
            get() {
                return this.settings.autoAssignDefaultLimit;
            },
            set(value) {
                this.updateSettings("autoAssignDefaultLimit", parseInt(value));
            },
        },
        lostConversationTime: {
            get() {
                return this.settings.lostConversationTime;
            },
            set(value) {
                this.updateSettings("lostConversationTime", parseInt(value));
            },
        },
        disconnectTime: {
            get() {
                return this.settings.disconnectTime;
            },
            set(value) {
                this.updateSettings("disconnectTime", parseInt(value));
            },
        },
        inactiveThresholdTime: {
            get() {
                return this.settings.inactiveThresholdTime;
            },
            set(value) {
                this.updateSettings("inactiveThresholdTime", parseInt(value));
            },
        },
        inactiveTerminateTime: {
            get() {
                return this.settings.inactiveTerminateTime;
            },
            set(value) {
                this.updateSettings("inactiveTerminateTime", parseInt(value));
            },
        },
    },
    methods: {
        readValue(id) {
            log("readValue", id, this.settings[id]);
            return this.settings[id];
        },
        setValue(id, value) {
            this.updateSettings(id, parseInt(value));
        },
    },
};
</script>

<style lang="scss">
.setting-page-content-wrapper {
    .features {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .right {
            .ant-input {
                text-align: center;
                min-width: 170px;
            }
        }
    }
}
</style>
